import { render, staticRenderFns } from "./SwipeHandler.vue?vue&type=template&id=50e290b5&scoped=true"
import script from "./SwipeHandler.vue?vue&type=script&lang=js"
export * from "./SwipeHandler.vue?vue&type=script&lang=js"
import style0 from "./SwipeHandler.vue?vue&type=style&index=0&id=50e290b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e290b5",
  null
  
)

export default component.exports